export function addPx(input) {
    if (String(input).endsWith('px')) {
        return String(input);
    }
    else {
        return `${input}px`;
    }
}
export function removePx(input) {
    return Number(input.replace(/px$/, ''));
}
